// extracted by mini-css-extract-plugin
module.exports = {"container":"resendButton_container__a-sjc button_button__2n_ir","faded":"resendButton_faded__2BaP2","countdownText":"resendButton_countdownText__3VBqA"};